// extracted by mini-css-extract-plugin
export default {"TCPchatRoom":"P1lSAc1wg1wyxl7X7nN2"};